import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden pt-20 pb-16 px-4" data-id="element-16">
      {/* Background effects */}
      <div className="absolute inset-0 bg-cosmic" data-id="element-17" />
      <div className="absolute inset-0 bg-stars" data-id="element-18" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-600/20 rounded-full blur-[120px] opacity-50 pointer-events-none" data-id="element-19" />

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-21">
          <span className="inline-block py-1 px-3 rounded-full bg-blue-500/10 text-blue-400 border border-blue-500/20 text-sm font-semibold tracking-wide uppercase mb-6" data-id="element-22">
            El Protocolo Andromeda
          </span>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-white leading-[1.1] mb-8 text-glow" data-id="element-23">
            Domina Meta Ads sin Segmentar por Intereses
          </h1>

          <p className="text-xl md:text-2xl text-slate-300 max-w-3xl mx-auto leading-relaxed mb-12" data-id="element-24">
            Deja de quemar tu presupuesto en públicos obsoletos y permite que el
            Algoritmo de Identidad encuentre a tus compradores de alto valor en
            piloto automático.
          </p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.3,
          duration: 0.5
        }} data-id="element-25">
            <CTAButton href="https://myschoolofbusiness.com//cart/47288827838658:1" data-id="element-26">
              QUIERO EL PROTOCOLO ANDROMEDA AHORA
            </CTAButton>
          </motion.div>
        </motion.div>

        {/* Product mockup image */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6,
        duration: 0.8,
        ease: 'easeOut'
      }} className="mt-16 relative" data-id="element-27">
          <div className="absolute inset-0 bg-purple-600/20 rounded-full blur-[80px] scale-75 pointer-events-none" data-id="element-28" />
          <img src="https://cdn.magicpatterns.com/uploads/1Z6jkShP8LqoxhxriPqEqJ/EL_PROTOCOLO_ANDROMEDA.png" alt="El Protocolo Andromeda - Guía en tablet y móvil" className="relative z-10 w-full max-w-lg mx-auto drop-shadow-[0_20px_60px_rgba(124,58,237,0.3)]" data-id="element-29" />
        </motion.div>
      </div>
    </section>;
}